import React, { useState, useEffect, useRef } from 'react';
import { Divider, Popconfirm, Card, Tooltip, Switch, Input, Button, Tag, Row, Col, Drawer, Space, Tabs, Form, DatePicker, Select, Spin, Modal } from 'antd';
import './container-report.css';
import Highlighter from 'react-highlight-words';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { SearchOutlined } from '@ant-design/icons';
import Table, { ColumnProps } from 'antd/lib/table';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { ContainerStatusEnum } from '@gtpl/shared-models/common-models';
import { SaleOrderDropDownDto } from '@gtpl/shared-models/sale-management';
import { ContainerReportModel } from '@gtpl/shared-models/logistics';
import {ContainerRegisterGrid} from '@gtpl/pages/logistics/logistics-components/container-register-grid';
import { ContainerRegisterService } from '@gtpl/shared-services/logistics';

const Option = Select;


/* eslint-disable-next-line */
export interface ContainerReportProps { }

export function ContainerReport(
  props: ContainerReportProps
) {
  const containerService = new ContainerRegisterService();
  const [form] = Form.useForm();
  const [searchedColumn, setSearchedColumn] = useState('');
  const [page, setPage] = React.useState(1);
  const searchInput = useRef(null);
  const [containerData, setContainerData] = useState<any>();
  const [searchText, setSearchText] = useState('');
  const [saleOrderId, setSaleOrderId] = useState<number>(undefined);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [saleOrderData, setSaleOrderData] = useState<SaleOrderDropDownDto[]>([]);
  const [data, setData] = useState<ContainerReportModel[]>([
    {
      "status": "NOT READY",
      "total": 0,
      "plantsdata": [
        {
          "plantId": 1,
          "qty": 0
        },
        {
          "plantId": 3,
          "qty": 0
        },
        {
          "plantId": 5,
          "qty": 0
        }
      ]
    },
    {
      "status": "READY TO BOOK",
      "total": 0,
      "plantsdata": [
        {
          "plantId": 1,
          "qty": 0
        },
        {
          "plantId": 3,
          "qty": 0
        },
        {
          "plantId": 5,
          "qty": 0
        }
      ]
    },
    {
      "status": "BOOKED",
      "total": 54,
      "plantsdata": [
        {
          "plantId": 1,
          "qty": 44
        },
        {
          "plantId": 3,
          "qty": 8
        },
        {
          "plantId": 5,
          "qty": 2
        }
      ]
    },
    {
      "status": "DISPATCHED TO PLANT",
      "total": 121,
      "plantsdata": [
        {
          "plantId": 1,
          "qty": 99
        },
        {
          "plantId": 3,
          "qty": 18
        },
        {
          "plantId": 5,
          "qty": 4
        }
      ]
    },
    {
      "status": "LOADING",
      "total": 17,
      "plantsdata": [
        {
          "plantId": 1,
          "qty": 9
        },
        {
          "plantId": 3,
          "qty": 8
        },
        {
          "plantId": 5,
          "qty": 0
        }
      ]
    },
    {
      "status": "LOADED AND SEALED",
      "total": 78,
      "plantsdata": [
        {
          "plantId": 1,
          "qty": 47
        },
        {
          "plantId": 3,
          "qty": 30
        },
        {
          "plantId": 5,
          "qty": 1
        }
      ]
    },
    {
      "status": "SHIPPED",
      "total": 57,
      "plantsdata": [
        {
          "plantId": 1,
          "qty": 36
        },
        {
          "plantId": 3,
          "qty": 20
        },
        {
          "plantId": 5,
          "qty": 1
        }
      ]
    },
    {
      "status": "OPEN",
      "total": 0,
      "plantsdata": [
        {
          "plantId": 1,
          "qty": 0
        },
        {
          "plantId": 3,
          "qty": 0
        },
        {
          "plantId": 5,
          "qty": 0
        }
      ]
    },
    {
      "status": "NOT RECEIVED",
      "total": 0,
      "plantsdata": [
        {
          "plantId": 1,
          "qty": 0
        },
        {
          "plantId": 3,
          "qty": 0
        },
        {
          "plantId": 5,
          "qty": 0
        }
      ]
    },
    {
      "status": "DRAFT RECEIVED",
      "total": 0,
      "plantsdata": [
        {
          "plantId": 1,
          "qty": 0
        },
        {
          "plantId": 3,
          "qty": 0
        },
        {
          "plantId": 5,
          "qty": 0
        }
      ]
    },
    {
      "status": "OBL RECEIVED",
      "total": 0,
      "plantsdata": [
        {
          "plantId": 1,
          "qty": 0
        },
        {
          "plantId": 3,
          "qty": 0
        },
        {
          "plantId": 5,
          "qty": 0
        }
      ]
    },
    {
      "status": "RECEIVED AND SHARED",
      "total": 0,
      "plantsdata": [
        {
          "plantId": 1,
          "qty": 0
        },
        {
          "plantId": 3,
          "qty": 0
        },
        {
          "plantId": 5,
          "qty": 0
        }
      ]
    }
  ])
  const saleOrderService = new SaleOrderService();

  useEffect(() => {
    getSaleOrderData(localStorage.getItem("unit_id"));
    getContainerReportData();
  }, []);

  const getContainerReportData =() =>{
    containerService.getContainerReportData().then(res =>{
      if(res.status){
        setContainerData(res.plantsdata);
        // AlertMessages.getErrorMessage("Data found")
      }
    })
  }
 

  

  const getSaleOrderData = (value) => {
    saleOrderService.getAllActiveSaleOrders({ plantId: value }).then((res) => {
      if (res.status) {
        console.log(res.data);
        setSaleOrderData(res.data);
      } else {
        if (res.intlCode) {
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
        setSaleOrderData([]);
      }
    }).catch((err) => {
      AlertMessages.getErrorMessage(err.message);
      setSaleOrderData([]);
    });
  }
  const handleSaleOrder = (value) => {
    console.log(value);

    setSaleOrderId(value);

  }
  const handleCancel = () => {
  
    setIsModalVisible(false);
  };

  function onFocus() {
    console.log('focus')
  }

  function onSearch(val) {
    console.log('search')
  }

  const constructDataSource = (responseData: ContainerReportModel[]) => {
    const dataSource = [];
    responseData.forEach(res => {
      const dataSourceObj = {};
      dataSourceObj['status'] = res.status;
      dataSourceObj['total'] = res.total;
      res.plantsdata.forEach(plant => {
        dataSourceObj[`plant_${plant.plantId}`] = plant.qty;
      });
      dataSource.push(dataSourceObj);
    });
    return dataSource;
  }

  const constructColumns = (responseData: ContainerReportModel[]): ColumnProps<any>[] => {
    const columns = [
      {
        title: 'Container Status',
        dataIndex: 'status',
        key: 'status',
      }
    ];
    responseData[0]?.plantsdata?.forEach(plant => {
        columns.push({
          title: `unit ${plant.plantId}`,
          dataIndex: `plant_${plant.plantId}`,
          key: `plant_${plant.plantId}`,
          
        })
      });
      columns.push(
        {
          title: 'Total',
          dataIndex: 'total',
          key: 'total',
        }
      )
    return columns;
  }
  return (
    <>
      <Card title={<span style={{ color: 'white' }}>Container Report</span>}
        style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }}></Card>

      <Table dataSource={constructDataSource(data)}
        columns={constructColumns(data)}

      ></Table>
         </>

  );
}



export default ContainerReport;
